import React, { FC } from 'react'
import { Modal, ModalProps } from '../../Modal'
import { CreateTemplateSheetModalContent } from './content'
import { useAppDispatch } from '../../../app/hooks'
import { handleTemplateSheetCreateModal} from '../../../features/modals/modalsSlice'


export const CreateTemplateModal: FC<ModalProps> = ({ opened, level }) => {
    const dispatch = useAppDispatch()

    const handleModal = () => {
        dispatch(handleTemplateSheetCreateModal())
    }
    return (
        <Modal opened={opened}>
            <CreateTemplateSheetModalContent level={level} handleModal={handleModal} />
        </Modal>
    )
}
